// https://github.com/jquense/yup
// Dead simple Object schema validation

import * as yup from "yup";

// Trimmed before the length checks because the values are trimmed before they are sent, and the server
// strips them too — validating the untrimmed input would reject padding the user never submits.
const trimValue = (value) => (typeof value === "string" ? value.trim() : value);

/**
 * The Expert header form has three shapes, and validation has to follow the shape actually rendered.
 * A form with no name inputs must not require a name — that would block every save for a viewer who
 * may edit the entity but not the person behind it.
 *
 * @param {Object} [options]
 * @param {boolean} [options.personNameFields] - The form renders first/last name, saved on the
 *   promoter profile that self-represents this expert.
 * @param {boolean} [options.entityNameField] - The form renders the entity's own `name`, which only
 *   an expert with no self-representing profile has (the server rejects renaming a self-expert here).
 */
const expertYupSchema = ({ personNameFields = false, entityNameField = false } = {}) =>
  yup.object().shape({
    ...(personNameFields && {
      first_name: yup
        .string()
        .transform(trimValue)
        .required("First name is required.")
        .max(50, "First name must be 50 characters or fewer."),
      last_name: yup
        .string()
        .transform(trimValue)
        .required("Last name is required.")
        .max(50, "Last name must be 50 characters or fewer."),
    }),
    ...(entityNameField && {
      name: yup
        .string()
        .transform(trimValue)
        .required("Name is required.")
        .min(2, "Name must be at least 2 characters.")
        .max(100, "Name must be 100 characters or fewer."),
    }),
    headline_custom: yup.string().transform(trimValue).max(200, "Headline must be 200 characters or fewer."),
    description: yup.string().transform(trimValue).max(2000, "About must be 2000 characters or fewer."),
    location_string: yup.string().nullable().max(100, "Location must be 100 characters or fewer."),
  });

export default expertYupSchema;
